/**
 * Copyright (C) BoostCommerce.net
 * This file is part of commercial BoostCommerce.net projects
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * Created on Mon Feb 13 2023 15:58:51
 */
// @flow
import _ from 'lodash';
import { getDayDiff } from 'src/helpers';

/**
 * Extract tenant app info
 * @param {*} tenantApp
 */
export const trackTenantInfoHotJar = (tenantApp: Object) => {
  const { tenantId } = tenantApp;
  const boostPlan = _.get(tenantApp, 'selectedPlan');
  const trialExpiresAt = _.get(tenantApp, 'trialExpiresAt');
  const trialExpired = _.get(tenantApp, 'trialExpired');
  const exceededPlan = _.get(tenantApp, 'exceededPlan');
  const now = Math.floor(Date.now() / 1000);

  let status = 'trial';
  if (exceededPlan) status = 'exceeded';
  else if (boostPlan) status = 'paid';
  else if (trialExpired) status = 'expired';
  else if (trialExpiresAt > now) status = 'trial';

  try {
    const firstInstalledAt = _.get(tenantApp, 'firstInstalledAt');
    const hotJarInfo = {
      tenantId,
      boostPlan,
      tenantStatus: status,
      recentInstalledAt: _.get(tenantApp, 'recentInstalledAt', firstInstalledAt),
      shopifyPlan: _.get(tenantApp, 'externalInfo.plan_name'),
      remainTrialDays: Math.max(getDayDiff(trialExpiresAt), 0)
    };

    localStorage.setItem(`${tenantId}-hotjar-tracking`, JSON.stringify(hotJarInfo));
  } catch (error) {}
};
